import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { CheckCircle, XCircle, Info, AlertTriangle, X } from "lucide-react";
import "../../assests/css/Toast.css";

export default function AppToast({
  message,
  type = "success",
  title,
  meta,
  onClose,
}) {
  useEffect(() => {
    if (!message) return undefined;
    const timer = setTimeout(() => onClose?.(), 3000);
    return () => clearTimeout(timer);
  }, [message, onClose]);

  if (!message) return null;

  const Icon =
    type === "success"
      ? CheckCircle
      : type === "warning"
        ? AlertTriangle
        : type === "info"
          ? Info
          : XCircle;

  return ReactDOM.createPortal(
    <div
      className={`custom-toast ${type} tone-${type === "error" ? "red" : type === "warning" ? "orange" : type === "success" ? "green" : "blue"}`}
      role="alert"
    >
      <div className="toast-content">
        <div
          className={`toast-icon-shell tone-${type === "error" ? "red" : type === "warning" ? "orange" : type === "success" ? "green" : "blue"}`}
        >
          <Icon size={22} className="toast-icon" />
        </div>
        <div className="toast-copy">
          <div className="toast-title">
            {title ||
              (type === "error"
                ? "Action failed"
                : type === "warning"
                  ? "Attention"
                  : type === "info"
                    ? "Information"
                    : "Success")}
          </div>
          <div className="toast-message">{message}</div>
          {meta ? <div className="toast-meta">{meta}</div> : null}
        </div>
        <button
          type="button"
          className="toast-close"
          onClick={() => onClose?.()}
          aria-label="Close notification"
        >
          <X size={18} />
        </button>
      </div>
    </div>,
    document.body,
  );
}
